import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import { useViewInfoProduct } from "@/Service/Api/Index";
import type { Price } from "@/Type/Price";
import React, { useCallback, useContext, useState } from "react";
import { useParams } from "react-router-dom";

type ProductContextType = {
  Products: ProductByIdPdp[];
  isLoading: boolean;
  Categories?: string;
  SubCategories?: string;
  AddQuantity: (count: number) => void;
  Quantitys: Price;
};

export const ProductContext = React.createContext<
  ProductContextType | undefined
>(undefined);

type paramCategorySubCategory = { category?: string; subcategory?: string };
//type paramSku = { idSku?: string };
type paramSku = { id?: string };

export const ContextProductProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { category, subcategory } = useParams<paramCategorySubCategory>();
  const { id } = useParams<paramSku>();
  const { mDatos: Productos, isLoading } = useViewInfoProduct(
    id!,
    category!,
    subcategory!
  );

  const [Quantity, setQuantity] = useState<number>(0);

  const Products = Productos ?? [];
  const Categories = category!;
  const SubCategories = subcategory!;
  const Quantitys = Quantity;

  const AddQuantity = useCallback((count: number) => {
    setQuantity(count);
  }, []);

  return (
    <ProductContext.Provider
      value={{
        Products,
        isLoading,
        Categories,
        SubCategories,
        AddQuantity,
        Quantitys,
      }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useContextProductData = () => {
  const context = useContext(ProductContext);
  if (!context)
    throw new Error(
      "useContextProductData must be used within a ContextProductProvider"
    );

  return context;
};
